<div
  class="tile-text"
  [ngClass]="
    data.tileAligment ? 'align-items-' + data.tileAligment : 'align-items-left'
  "
>
  <p [ngStyle]="data?.itemStyleOutput" [innerHTML]="htmlText"></p>
</div>
